module.exports = __webpack_public_path__ + "img/calendar-18.fed05a32.svg";